(function () {
  'use strict';
  var root = document.querySelector('[data-cart-page]');
  if (!root) return;
  var busy = false, uncertain = false, giftTries = 0;
  function message(text, error) {
    var el = root.querySelector('[data-cart-status]');
    el.hidden = !text;
    el.textContent = text;
    el.toggleAttribute('data-error', !!error);
  }
  function lock(value) {
    busy = value;
    root.setAttribute('aria-busy', String(value));
    root.querySelectorAll('button,input').forEach(function (el) { el.disabled = value || uncertain; });
  }
  function replace(html) {
    if (!html) throw new Error('No pudimos actualizar el resumen.');
    var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-page]');
    if (!next) throw new Error('No pudimos actualizar el resumen.');
    root.innerHTML = next.innerHTML;
    uncertain = false;
  }
  function refresh() {
    var url = new URL(root.dataset.cartUrl, window.location.origin);
    url.searchParams.set('section_id', root.dataset.sectionId);
    return fetch(url.href, { cache: 'no-store' }).then(function (response) {
      if (!response.ok) throw new Error('No pudimos verificar el carrito.');
      return response.text();
    }).then(replace);
  }
  function applied(cart, code) {
    var target = code.toUpperCase();
    if ((cart.discount_codes || []).some(function (d) { return d.code.toUpperCase() === target && d.applicable; })) return true;
    var discounts = (cart.cart_level_discount_applications || []).slice();
    (cart.items || []).forEach(function (line) {
      (line.line_level_discount_allocations || []).forEach(function (d) { discounts.push(d.discount_application); });
    });
    return discounts.some(function (d) { return String(d.title).toUpperCase() === target; });
  }
  function update(url, data, code, focusKey, quiet) {
    if (busy || uncertain) return;
    if (!quiet) giftTries = 0;
    var sectionId = root.dataset.sectionId;
    data.sections = [sectionId];
    data.sections_url = root.dataset.cartUrl;
    lock(true);
    if (!quiet) message('Actualizando tu carrito…');
    return fetch(url, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)})
      .then(function (response) { return response.json().then(function (cart) {
        if (!response.ok || cart.status >= 400) throw new Error(cart.description || 'No pudimos actualizar tu carrito.');
        return cart;
      }); })
      .then(function (cart) {
        var html = cart.sections && cart.sections[sectionId];
        var rendered = html ? Promise.resolve().then(function () { replace(html); }) : refresh();
        return rendered.then(function () {
          if (quiet) return;
          if (code) message(applied(cart, code) ? 'Código aplicado.' : 'Este código no se puede aplicar a tu carrito.', !applied(cart, code));
          else message('Carrito actualizado.');
        });
      })
      .catch(function (error) {
        // Ajustar regalos es secundario: reconciliar en silencio.
        if (quiet) return refresh().catch(function () {});
        // Un POST incierto nunca se repite: reconciliar con Shopify antes de habilitar pago.
        return refresh().then(function () { message(error.message, true); }).catch(function () {
          uncertain = true;
          message('No pudimos verificar el total. Recarga la página antes de continuar al pago.', true);
        });
      })
      .finally(function () {
        lock(false);
        if (quiet) { syncGifts(); return; }
        var line = Array.from(root.querySelectorAll('[data-cart-line]')).find(function (el) { return el.dataset.key === focusKey; });
        var focus = line && line.querySelector('[data-cart-quantity]');
        if (!focus) focus = root.querySelector('[data-cart-status]');
        if (focus) focus.focus();
        syncGifts();
      });
  }
  /* Regalos del pack: con packs en el carrito, cada regalo disponible queda en 1;
     sin packs, se quitan. El estado llega desde Liquid en [data-gift-state]. */
  function giftUpdates() {
    var el = root.querySelector('[data-gift-state]');
    var state;
    try { state = JSON.parse(el.textContent); } catch (_) { return null; }
    var want = state.want.map(String);
    var target = state.paid > 0 ? 1 : 0;
    var updates = null;
    want.concat(Object.keys(state.have)).forEach(function (id) {
      var have = state.have[id] || 0;
      var next = target && want.indexOf(id) < 0 ? have : target;
      if (have !== next) { updates = updates || {}; updates[id] = next; }
    });
    return updates;
  }
  function syncGifts() {
    var updates = giftUpdates();
    if (!updates || giftTries > 1) return;
    giftTries += 1;
    update(root.dataset.updateUrl, { updates: updates }, null, null, true);
  }
  function change(line, quantity) {
    var input = line.querySelector('[data-cart-quantity]');
    if (!Number.isInteger(quantity) || quantity < 0 || (input.max && quantity > Number(input.max))) {
      input.value = input.dataset.current;
      message('Revisa la cantidad de packs.', true);
      return;
    }
    if (quantity === Number(input.dataset.current)) return;
    return update(root.dataset.changeUrl, {id:line.dataset.key,quantity:quantity}, null, line.dataset.key);
  }
  function applyCode() {
    var input = root.querySelector('#lz-cart-code');
    var code = input.value.trim();
    if (!code) { input.focus(); return; }
    return update(root.dataset.updateUrl, {discount:code}, code);
  }
  root.addEventListener('click', function (event) {
    var delta = event.target.closest('[data-cart-delta]');
    var remove = event.target.closest('[data-cart-remove]');
    var apply = event.target.closest('[data-cart-apply]');
    if (!delta && !remove && !apply) return;
    event.preventDefault();
    if (busy || uncertain) return;
    if (apply) { applyCode(); return; }
    var line = (delta || remove).closest('[data-cart-line]');
    var input = line.querySelector('[data-cart-quantity]');
    change(line, remove ? 0 : Math.max(0, Number(input.dataset.current) + Number(delta.dataset.cartDelta) * Number(input.step || 1)));
  });
  root.addEventListener('change', function (event) {
    if (event.target.matches('[data-cart-quantity]')) change(event.target.closest('[data-cart-line]'), Number(event.target.value));
  });
  root.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    if (event.target.id === 'lz-cart-code') { event.preventDefault(); applyCode(); }
    if (event.target.matches('[data-cart-quantity]')) { event.preventDefault(); change(event.target.closest('[data-cart-line]'), Number(event.target.value)); }
  });
  root.addEventListener('submit', function (event) {
    if (busy || uncertain) { event.preventDefault(); return; }
    // Checkout es el formulario nativo; no se emiten eventos de compra manuales.
    var changed = Array.from(root.querySelectorAll('[data-cart-quantity]')).find(function (input) { return Number(input.value) !== Number(input.dataset.current); });
    if (changed) { event.preventDefault(); change(changed.closest('[data-cart-line]'), Number(changed.value)); }
  });
  syncGifts();
})();
